import { render, staticRenderFns } from "./CoinDetail.vue?vue&type=template&id=14599b49&"
import script from "./CoinDetail.vue?vue&type=script&lang=js&"
export * from "./CoinDetail.vue?vue&type=script&lang=js&"
import style0 from "./CoinDetail.vue?vue&type=style&index=0&scopede=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports